import { useEffect, useState } from 'react'

/**
 * Leniwe ładowanie SDK operatora. Adresy przychodzą z backendu (cardForm.sdkUrl),
 * nigdy ich nie hardkodujemy - to backend rozróżnia sandbox od produkcji.
 */

const loaded = new Map<string, Promise<void>>()

export const loadScript = (url: string): Promise<void> => {
  if (!url) return Promise.reject(new Error('script_url_missing'))

  if (!loaded.has(url)) {
    loaded.set(url, new Promise<void>((resolve, reject) => {
      const script = document.createElement('script')
      script.src = url
      script.async = true
      script.onload = () => resolve()
      script.onerror = () => {
        loaded.delete(url)
        reject(new Error(`script_load_failed: ${url}`))
      }
      document.head.appendChild(script)
    }))
  }

  return loaded.get(url) as Promise<void>
}

export type ScriptState = 'idle' | 'loading' | 'ready' | 'error'

export const useScript = (url?: string) => {
  const [state, setState] = useState<ScriptState>(url ? 'loading' : 'idle')

  useEffect(() => {
    if (!url) {
      setState('idle')
      return
    }

    let alive = true
    setState('loading')
    loadScript(url).then(
      () => alive && setState('ready'),
      () => alive && setState('error')
    )

    return () => {
      alive = false
    }
  }, [url])

  return state
}
